module.exports = __webpack_public_path__ + "img/interior2.16b4e422.png";